/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Me401Response,
  StartAConversationAboutACarRequest,
} from '../models/index';
import {
    Me401ResponseFromJSON,
    Me401ResponseToJSON,
    StartAConversationAboutACarRequestFromJSON,
    StartAConversationAboutACarRequestToJSON,
} from '../models/index';

export interface MarkAConversationAsReadRequest {
    conversationId: number;
}

export interface ShowAConversationRequest {
    id: number;
}

export interface StartAConversationAboutACarOperationRequest {
    startAConversationAboutACarRequest: StartAConversationAboutACarRequest;
}

/**
 * ConversationsApi - interface
 * 
 * @export
 * @interface ConversationsApiInterface
 */
export interface ConversationsApiInterface {
    /**
     * Returns the authenticated user\'s inbox — every conversation they participate in, newest activity first. Supports `filter[car_id]=X` to restrict to one car.
     * @summary List my conversations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApiInterface
     */
    listMyConversationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Returns the authenticated user\'s inbox — every conversation they participate in, newest activity first. Supports `filter[car_id]=X` to restrict to one car.
     * List my conversations
     */
    listMyConversations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Sets `last_read_at` for the current participant to now. Used to clear unread badges.
     * @summary Mark a conversation as read
     * @param {number} conversationId The ID of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApiInterface
     */
    markAConversationAsReadRaw(requestParameters: MarkAConversationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Sets `last_read_at` for the current participant to now. Used to clear unread badges.
     * Mark a conversation as read
     */
    markAConversationAsRead(requestParameters: MarkAConversationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns the conversation with its full message thread. 404 if the authenticated user is not a participant (we return 404 instead of 403 to avoid leaking existence).
     * @summary Show a conversation
     * @param {number} id The ID of the conversation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApiInterface
     */
    showAConversationRaw(requestParameters: ShowAConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Returns the conversation with its full message thread. 404 if the authenticated user is not a participant (we return 404 instead of 403 to avoid leaking existence).
     * Show a conversation
     */
    showAConversation(requestParameters: ShowAConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Finds-or-creates a conversation between the authenticated user and the owner of the given car. Accepts an optional initial message body — if provided, it is posted immediately and the car owner receives a `NewMessageReceived` notification. You cannot start a conversation with yourself.
     * @summary Start a conversation about a car
     * @param {StartAConversationAboutACarRequest} startAConversationAboutACarRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConversationsApiInterface
     */
    startAConversationAboutACarRaw(requestParameters: StartAConversationAboutACarOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Finds-or-creates a conversation between the authenticated user and the owner of the given car. Accepts an optional initial message body — if provided, it is posted immediately and the car owner receives a `NewMessageReceived` notification. You cannot start a conversation with yourself.
     * Start a conversation about a car
     */
    startAConversationAboutACar(requestParameters: StartAConversationAboutACarOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ConversationsApi extends runtime.BaseAPI implements ConversationsApiInterface {

    /**
     * Returns the authenticated user\'s inbox — every conversation they participate in, newest activity first. Supports `filter[car_id]=X` to restrict to one car.
     * List my conversations
     */
    async listMyConversationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/conversations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns the authenticated user\'s inbox — every conversation they participate in, newest activity first. Supports `filter[car_id]=X` to restrict to one car.
     * List my conversations
     */
    async listMyConversations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.listMyConversationsRaw(initOverrides);
    }

    /**
     * Sets `last_read_at` for the current participant to now. Used to clear unread badges.
     * Mark a conversation as read
     */
    async markAConversationAsReadRaw(requestParameters: MarkAConversationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling markAConversationAsRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/conversations/{conversation_id}/read`;
        urlPath = urlPath.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters['conversationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets `last_read_at` for the current participant to now. Used to clear unread badges.
     * Mark a conversation as read
     */
    async markAConversationAsRead(requestParameters: MarkAConversationAsReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.markAConversationAsReadRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the conversation with its full message thread. 404 if the authenticated user is not a participant (we return 404 instead of 403 to avoid leaking existence).
     * Show a conversation
     */
    async showAConversationRaw(requestParameters: ShowAConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showAConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/conversations/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Returns the conversation with its full message thread. 404 if the authenticated user is not a participant (we return 404 instead of 403 to avoid leaking existence).
     * Show a conversation
     */
    async showAConversation(requestParameters: ShowAConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.showAConversationRaw(requestParameters, initOverrides);
    }

    /**
     * Finds-or-creates a conversation between the authenticated user and the owner of the given car. Accepts an optional initial message body — if provided, it is posted immediately and the car owner receives a `NewMessageReceived` notification. You cannot start a conversation with yourself.
     * Start a conversation about a car
     */
    async startAConversationAboutACarRaw(requestParameters: StartAConversationAboutACarOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['startAConversationAboutACarRequest'] == null) {
            throw new runtime.RequiredError(
                'startAConversationAboutACarRequest',
                'Required parameter "startAConversationAboutACarRequest" was null or undefined when calling startAConversationAboutACar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/conversations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartAConversationAboutACarRequestToJSON(requestParameters['startAConversationAboutACarRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finds-or-creates a conversation between the authenticated user and the owner of the given car. Accepts an optional initial message body — if provided, it is posted immediately and the car owner receives a `NewMessageReceived` notification. You cannot start a conversation with yourself.
     * Start a conversation about a car
     */
    async startAConversationAboutACar(requestParameters: StartAConversationAboutACarOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startAConversationAboutACarRaw(requestParameters, initOverrides);
    }

}
